import { Outlet, createFileRoute } from '@tanstack/react-router';

import Reporting from 'component/view/SiteDetails/Reporting';

import { requireOperation } from './-guards';
import { siteTabOperations } from './-site-tabs';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/reporting')({
  beforeLoad: requireOperation({
    options: ({ params }) => siteTabOperations.reporting(params.siteId),
    siteId: ({ params }) => params.siteId,
  }),
  component: ReportingLayout,
});

function ReportingLayout() {
  return (
    <Reporting>
      <Outlet />
    </Reporting>
  );
}
